import { Editor } from "@tiptap/react"
import { createContext, useCallback, useState, ReactNode } from "react"


type LinkContextProps = {
  url: string
  modalIsOpen: boolean
  closeModal: () => void
  setUrl(value: string): void
  saveLink: () => void
  removeLink: () => void
  openModal: () => void
}

export const LinkContext = createContext<LinkContextProps | undefined>(undefined)

type LinkContextProviderProps = {
  editor: Editor
  children: ReactNode
}

export const LinkContextProvider = ({ editor, children } : LinkContextProviderProps) => {

    const [modalIsOpen, setIsOpen] = useState(false);
    const [url, setUrl] = useState<string>("");
    
    const openModal = useCallback(() => {
      setUrl(editor.getAttributes("link").href);
      setIsOpen(true);
    }, [editor]);
    
    const closeModal = useCallback(() => {
      setIsOpen(false);
      setUrl("");
    }, []);
    
    const saveLink = useCallback(() => {
      if (url) {
        editor
          .chain()
          .focus()
          .extendMarkRange("link")
          .setLink({ href: url, target: "_blank" })
          .run();
      } else {
        editor.chain().focus().extendMarkRange("link").unsetLink().run();
      }
      closeModal();
    }, [editor, url, closeModal]);
    
    const removeLink = useCallback(() => {
      editor.chain().focus().extendMarkRange("link").unsetLink().run();
      closeModal();
    }, [editor, closeModal]);


    return <LinkContext.Provider value={{url, modalIsOpen, closeModal, setUrl, saveLink, removeLink, openModal }}>{children}</LinkContext.Provider>
}